import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetSingleUserQuery, useEditUserMutation } from "./adminApiSlice";
import { FaEyeSlash, FaRegEye } from "react-icons/fa6";
import { AiOutlineSave } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import { selectCurrentToken, setCredentials } from "../auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import SelectBox from "../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";

const roles = [
  { label: "Creator", value: "Creator" },
  { label: "Explorer", value: "Explorer" },
  { label: "Viewer", value: "Viewer" },
];

export default function EditUser() {
  const [uploadStatus, setUploadStatus] = useState(""); // To show status messages

  const handlefileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadStatus("Uploading..."); // Show uploading message

    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "Upload_image_vizta");
    data.append("cloud_name", "dccfiolig");

    try {
      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dccfiolig/image/upload",
        {
          method: "POST",
          body: data,
        }
      );

      if (!res.ok) {
        throw new Error("Upload failed!");
      }

      const uploadedImageURL = await res.json();
      // console.log(uploadedImageURL.url);
      const requiredImageURL = uploadedImageURL.url;

      setUploadStatus({
        message: "Upload successful!",
        imageURL: requiredImageURL,
      }); // Update status
    } catch (error) {
      console.error(error);
      setUploadStatus("Upload failed!"); // Update status
    }
  };
  const dispatch = useDispatch();
  const token = useSelector(selectCurrentToken);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("user");
  // console.log(userId);
  
  // // console.log(userId);
  const navigate = useNavigate();
  const {
    data: userData,
    isUserDataLoading,
    isUserDataError,
    userDataError,
  } = useGetSingleUserQuery(userId);
  const [editUser, { data: editedUserData, isEditUserLoading, editUserError }] =
    useEditUserMutation();
  const [editUserData, setEditUserData] = useState(null);
  // console.log(editUserData);
  const [checkUserFields, setCheckUserFields] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const receivedRole =
    editUserData !== null && Object.keys(editUserData.roles)
      ? Object.keys(editUserData.roles)[0]
      : null;

  const [role, setRole] = useState(null);

  useEffect(() => {
    if (editUserData !== null) {
      if (editUserData.email === "") {
        setCheckUserFields("email field is empty");
      }
      if (editUserData.username === "") {
        setCheckUserFields("username field is empty");
      }
      if (password !== confirmPassword) {
        setCheckUserFields("password and confirm password is not same");
      }
      if (
        editUserData.username &&
        editUserData.email &&
        password === confirmPassword
      ) {
        setCheckUserFields("");
      }
    }
  }, [editUserData, password, confirmPassword]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditUserData((prev) => ({ ...prev, [name]: value }));
    if (name === "password") {
      setPassword(value);
    }
    if (name === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  const handleRoleChange = (e) => {
    // console.log(e.target.value);
    setRole(e.target.value);
  };
  useEffect(() => {
    if (userData) {
      setEditUserData(userData);
    }
    if (receivedRole) {
      setRole(receivedRole);
    }
  }, [userId, userData, receivedRole]);
  useEffect(() => {
    if (editedUserData && editedUserData[`message`]) {
      const timer = setTimeout(() => {
        navigate("/home/dash/admin");
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [editedUserData]);

  const handleSave = () => {
    // console.log(editUserData);

    const logo = uploadStatus?.imageURL ? uploadStatus.imageURL : null;

    // Build newDetails object conditionally
    const newDetails = {
      email: editUserData.email,
      dob: editUserData.dob,
      phone: editUserData.phone,
      zone: editUserData.zone,
      region: editUserData.region,
      roles: role,
      userCompanylogo: logo,
    };

    // Include password only if confirmPassword is not empty or null
    if (confirmPassword) {
      newDetails.password = confirmPassword;
    }

    const updatedUser = {
      userId: editUserData._id,
      newDetails,
    };

    // Dispatch setCredentials only if token and logo exist
    if (token && logo) {
      dispatch(setCredentials({ accessToken: token, logo }));
    }

    // console.log(updatedUser);

    // Call editUser with the updatedUser object
    editUser(updatedUser);
  };

  if (isUserDataLoading) {
    return <LoadingIndicator />;
  }
  if (isUserDataError) {
    // console.log(userDataError);
    return (
      <main className="flex w-full h-[92vh] px-[0.8rem] items-start justify-start">
        {userDataError}
      </main>
    );
  }
  if (editUserData !== null) {
    // // console.log(editUserData);
    return (
      <main className="overflow-hidden flex flex-col w-full h-[92vh]">
        <section className="flex items-center justify-start px-[0.8rem] border border-b-0 border-gray-300 h-[6%] font-medium w-full gap-2">
          {editUserData.username}
          {editUserError ? (
            <p className="text-red-500 font-medium">
              {editUserError[`message`]}
            </p>
          ) : null}
          {editedUserData ? (
            <p className="text-green-500 font-medium">
              {editedUserData[`message`]}
            </p>
          ) : null}
        </section>
        <section className="flex flex-wrap items-start justify-start p-[0.8rem] border border-b-0 border-gray-300 h-[65%] w-full">
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="username" className="font-medium">
              Username
            </label>
            <input
              type="text"
              name="username"
              placeholder="user123"
              value={editUserData.username}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="email" className="font-medium">
              Email
            </label>
            <input
              type="email"
              name="email"
              placeholder="user123@gmail.com"
              value={editUserData.email}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="password" className="font-medium">
              Password
            </label>
            <div className="relative w-full">
              <input
                type={passwordVisible ? "text" : "password"}
                name="password"
                placeholder="enter the new password"
                onChange={handleInputChange}
                value={password}
                className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
              />
              <button
                type="button"
                className="absolute right-[13.5%] top-[20.8%] focus:outline-0"
                onClick={() => setPasswordVisible(!passwordVisible)}
              >
                {passwordVisible ? <FaRegEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="confirmPassword" className="font-medium">
              Confirm Password
            </label>
            <div className="relative w-full">
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                name="confirmPassword"
                placeholder="confirm the new password"
                onChange={handleInputChange}
                className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
              />
              <button
                type="button"
                className="absolute right-[13.5%] top-[20.8%] focus:outline-0"
                value={confirmPassword}
                onClick={() =>
                  setConfirmPasswordVisible(!confirmPasswordVisible)
                }
              >
                {confirmPasswordVisible ? <FaRegEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="dob" className="font-medium">
              Date of Birth
            </label>
            <input
              type="date"
              name="dob"
              onChange={handleInputChange}
              value={
                editUserData.dob
                  ? new Date(editUserData.dob).toISOString().split("T")[0]
                  : ""
              }
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="phone" className="font-medium">
              Phone Number
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="1234567890"
              value={editUserData.phone}
              onChange={(e) => {
                const { value } = e.target;
                if (/^\d*$/.test(value)) {
                  handleInputChange(e);
                }
              }}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="zone" className="font-medium">
              Zone
            </label>
            <input
              type="text"
              name="zone"
              placeholder="Zone"
              onChange={handleInputChange}
              value={editUserData.zone}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="region" className="font-medium">
              Region
            </label>
            <input
              type="text"
              name="region"
              placeholder="Region"
              value={editUserData.region}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="hierarchy" className="font-medium">
              Hierarchy
            </label>
            <input
              type="text"
              name="hierarchy"
              placeholder="Hierarchy"
              value={editUserData.hierarchy}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex flex-col w-[33%] items-start justify-start gap-2">
            <label htmlFor="department" className="font-medium">
              Department
            </label>
            <input
              type="text"
              name="department"
              placeholder="Department"
              value={editUserData.department}
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
          </div>
          <div className="flex w-[33%] items-center justify-start gap-2 relative top-[6%]">
            <label htmlFor="role" className="font-medium">
              Role
            </label>
            <div className="w-[78%]">
              <SelectBox
                value={role}
                onChange={handleRoleChange}
                optionsArray={roles}
              />
            </div>
          </div>

          <div className="flex flex-col w-[33%] items-start justify-start gap-2 ">
            <label htmlFor="fileUpload" className="font-medium">
              Choose File
            </label>
            <input
              type="file"
              name="fileUpload"
              id="fileUpload"
              onChange={handlefileUpload} // Automatically uploads file on selection
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
            {uploadStatus && (
              <p className="text-sm font-medium mt-2">{uploadStatus.message}</p> // Show upload status
            )}
          </div>
        </section>
        <section className="flex items-center justify-end w-full h-[10%] px-[5rem] py-[0.8rem] gap-4">
          {checkUserFields !== "" ? (
            <p className="text-red-500 font-medium">{checkUserFields}</p>
          ) : null}
          <button
            className="border rounded py-2 px-3 text-gray-700 hover:bg-gray-200"
            onClick={() => navigate("/home/dash/admin")}
          >
            Cancel
          </button>
          <button
            className={`border rounded py-2 px-6  flex items-center justify-center gap-1 text-white ${
              checkUserFields !== "" ? " bg-gray-500" : " bg-blue-950"
            }`}
            onClick={handleSave}
            disabled={checkUserFields !== ""}
          >
            {isEditUserLoading ? "Saving..." : "Save"}
            <AiOutlineSave />
          </button>
        </section>
      </main>
    );
  }
}
